import React from "react";
import { Provider } from "react-redux";
import { store, history } from "../redux/store";
import PublicRoutes from "../router";

const MainApp = () => (
    <Provider store={store}>
      <PublicRoutes history={history} />
    </Provider>
);

MainApp();

export default MainApp;



// WEBPACK FOOTER //
// ./src/component/index.js